import { createSlice } from '@reduxjs/toolkit';

export const LeasesSlice = createSlice({
	name: 'leasesFilters',
	initialState: {
		sortBy: 'Encoder/Asc',
		filters: {
			Future: true,
			Closed: true,
			Out: true,
		},
		searchQuery: '',
	},
	reducers: {
		setSortBy: (state, action) => {
			state.sortBy = action.payload;
		},
		setFilters: (state, action) => {
			state.filters = action.payload;
		},
		setQuery: (state, action) => {
			state.searchQuery = action.payload;
		},
	},
});

export const { setSortBy, setFilters, setQuery } = LeasesSlice.actions;

export default LeasesSlice.reducer;
